import { combineReducers } from '@reduxjs/toolkit'

import bom from 'product_tabs/tab_parts/bomSlice';
import alert from 'product_tabs/alerts/alertSlice';
import assembly from 'product_tabs/tab_assembly/assemblySlice';
import tab from 'us_pcb_assembly/tabs/tabSlice';

const rootReducer = combineReducers({
  bom,
  tab,
  alert,
  assembly,
});

export default rootReducer
